// @flow

import { type IncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import { isDemonstrationMerchant } from '@tectonics/prs/merchant';

const UNSUPPORTED_CURRENCY_SYMBOL_PATTERN = /Currency symbol not supported/;

/**
 * The Demonstration Merchant can be configured with test currencies that the
 * checkout does not render (e.g. AUD), making `getCurrencySymbol` throw
 * "Currency symbol not supported". On real merchants this is a genuine bug,
 * but on the Demonstration Merchant it is expected test noise, so we downgrade
 * it from error to warning instead of reporting it as an error.
 */
export function shouldReportAsWarning(error: ?Error, incomingPayment: ?IncomingPayment): boolean {
  if (!error || !incomingPayment) {
    return false;
  }

  const merchant = getMerchant(incomingPayment);
  if (!merchant || !isDemonstrationMerchant(merchant)) {
    return false;
  }

  return UNSUPPORTED_CURRENCY_SYMBOL_PATTERN.test(error.message || '');
}
